import type { TFunction } from "i18next";

export type LanguageOption = {
  code: string;
  getLabel: (t: TFunction) => string;
  /** ISO 3166-1 alpha-2 country code used to render the SVG flag */
  countryCode: string;
};

export const languageOptions: LanguageOption[] = [
  {
    code: "it",
    getLabel: (t: TFunction) => t("lingue.italiano"),
    countryCode: "IT",
  },
  {
    code: "en",
    getLabel: (t: TFunction) => t("lingue.inglese"),
    countryCode: "GB",
  },
  {
    code: "de",
    getLabel: (t: TFunction) => t("lingue.tedesco"),
    countryCode: "DE",
  },
];

export const getLanguageOption = (code?: string | null) =>
  languageOptions.find((language) => language.code === code) ??
  languageOptions[0];
